class MicroFrontendEventManager {
  static subscribe(eventName: string, handler: EventListenerOrEventListenerObject): void {
    window.addEventListener(eventName, handler);
  }

  static unsubscribe(eventName: string, handler: EventListenerOrEventListenerObject): void {
    window.removeEventListener(eventName, handler);
  }

  static dispatch(eventName: string, detail?: Record<string, unknown>): void {
    const event = new CustomEvent(eventName, detail);
    window.dispatchEvent(event);
  }
}

export default MicroFrontendEventManager;
